import {FelloEnv} from "fello-model";
import {Environment} from "./environment-type";

const devFelloBaseURL = "https://api-dev.hifello.com";

const baseURL = devFelloBaseURL;
export const environment: Environment = {
  env: FelloEnv.DEV,
  production: true,
  felloApiBaseUrl: `${baseURL}/api/v2`,
  paymentApiBaseUrl: `${baseURL}/api/v2`,
  agentServiceBaseURL: "https://api-dev.hifello.com/api/v2",
  hiFelloBaseUrl: "https://dev.hifello.com",
  felloConnectBaseUrl: "https://connect-dev.hifello.com/",
  googleClientId: "213610769932-s1g4a69abctor9o7ngvtk24gqli4j6fa.apps.googleusercontent.com",
  appleAuthClientId: "com.hifello.login.development",
  hubspotTrackingScriptSrc: "https://js.hs-scripts.com/21921470.js",
  mixPanelApiKey: "d626948447f8c5eb4543dbe59ef98c55",
  googleStreetViewApiKey: "AIzaSyCn2MqSX57zjt_txnWwqGlp51FgP94t_Ts",
  mediaServiceBaseURL: "https://api-dev.hifello.com/api/v2",
  googleMapsApiKey: "AIzaSyBfEwYR5QelpCR6y03Zk7o0decOcyV2mAY",
  enableSubdomainFixing: false,
  allowedSubdomains: ["consumer-dev"],
  smartyStreetsBaseURL: "https://us-autocomplete-pro.api.smarty.com/lookup?key=10196474929056213",
  consumerApiBaseUrl: "https://consumer-dev.hifello.com/api/v2",
  sentryDsn: "",
  sentryTracesSampleRate: 0
};
